import React from 'react';
import SignupEmailForm from '../components/SignupEmailForm';
import { useLocation } from 'react-router-dom';
import SignupPasswordForm from '../components/SignupPasswordForm';
import OTPVerificationForm from '../components/OTPVerificationForm';
import { Grid } from '@mui/material';
import signup_bg from '../../../assets/signup/signup_bg.svg';

const SignupPage = () => {
  const location = useLocation();
  let state = location.state;

  const getComponent = () => {
    if (state?.email) {
      if (state.stage === 'verification') {
        return <OTPVerificationForm email={state.email} />;
      }
      return <SignupPasswordForm email={state?.email} />;
    }

    return <SignupEmailForm />;
  };

  return (
    <Grid
      container
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        p: '20px',
      }}
    >
      <Grid
        size={{ xs: 0, lg: 7, xl: 6 }}
        sx={{
          display: { sm: 'none', lg: 'flex' },
        }}
      >
        <img src={signup_bg} alt="signup background" width="100%" style={{ display: 'flex' }} />
      </Grid>
      <Grid size={{ xs: 1, sm: 2, md: 3, lg: 1, xl: 2 }} />
      <Grid size={{ xs: 10, sm: 8, md: 6, lg: 3, xl: 3 }}>{getComponent()}</Grid>
      <Grid size={{ xs: 1, sm: 2, md: 3, lg: 1, xl: 1 }} />
    </Grid>
  );
};

export default SignupPage;
